import React from 'react';
import { Link } from 'react-router-dom'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "./../../components/Language";
import "./apibind.scss"

import ArrowForword from './../../assets/images/icons/arrow_forword.svg';

import Api1 from './../../assets/images/icons/api1.svg';
import BybitLogo from './../../assets/images/icons/bybit.svg';
import { IconLock } from '../../components/Icons';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import _ from 'lodash';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class APIBindScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			lang: strings.getLanguage(),
			access_token: "",
			data: [],
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				this.setState({ access_token: token });
				this.getData();
			});
		}
	}

	comingSoon() {
		toast.warning(strings.Coming_Soon);
	}

	getData() {
		const { setLoading } = this.context;
		var self = this;
		if (self.state.access_token) {
			setLoading(true);
			axios({
				method: 'GET',
				url: api.bind_trading_platform,
				headers: {
					'Authorization': 'Bearer ' + self.state.access_token,
					'Content-Type': 'application/json',
					'Accept-Language': strings.getLanguage(),
				}
			}).then(function (ress) {
				if (ress.data && ress.data.error === 200) {
					self.setState({ data: ress.data.data });
				} else {
					if (ress.data.validation && ress.data.validation.length !== 0) {
						_.forEach(ress.data.validation, function (value) {
							if (value[0]) {
								toast.error(value[0]);
							}
						});
					} else {
						toast.error(ress.data.message);
					}
				}
				setTimeout(() => {
					setLoading(false);
				});
			}).catch(function (e) {
				setLoading(false);
			});
		}
	};

	// Platforms we no longer offer are hidden; ones listed in LOCKED show but can't be bound yet.
	static HIDDEN = ["huobi", "coinbase"];
	static LOCKED = ["bybit"];

	platforms() {
		const list = (this.state.data || []).filter(
			(p) => !APIBindScreen.HIDDEN.includes(String(p.name || "").toLowerCase())
		);
		// Bybit isn't returned by the API yet — show it locked so users know it's coming
		if (!list.some((p) => String(p.name || "").toLowerCase() === "bybit")) {
			list.push({ id: "bybit", name: "Bybit", icon: BybitLogo, is_binded: 0 });
		}
		return list;
	}

	renderRowBody(item, locked) {
		return (
			<div className={`flex-center ${item.is_binded ? "api_list_back_active" : "api_list_back"}${locked ? " api_list_locked" : ""}`} style={{
				justifyContent: "space-between", padding: 10, borderRadius: 5
			}}>
				<div className='flex-center' style={{ flexDirection: "row" }}>
					<img src={item.icon ? item.icon : Api1} alt="" width={30} height={30} style={{ borderRadius: 8 }}></img>
					<div style={{ marginLeft: 10 }}>
						<span style={{ fontSize: 14 }}>{item.name}</span>
					</div>
				</div>
				<div className='flex-center' style={{ flexDirection: "row" }}>
					{locked ?
						<div className='api_lock_pill'>
							<IconLock size={14} strokeWidth={2.2} />
							<span>{strings.Coming_Soon}</span>
						</div>
						:
						<>
							<div className='back_inputColor' style={{ marginRight: 10, paddingLeft: 10, paddingRight: 10, borderRadius: 20, paddingTop: 5, paddingBottom: 5 }}>
								<span style={{ fontSize: 14 }}>{item.is_binded ? strings.bound : strings.unbound}</span>
							</div>
							<img src={ArrowForword} alt=""></img>
						</>
					}
				</div>
			</div>
		);
	}

	render() {
		return (
			<SubLayout data={{ "title": strings.api_bind }}>
				<div style={{ margin: 10 }}>
					<List>
						{
							this.platforms().map((item, i) => {
								const locked = APIBindScreen.LOCKED.includes(String(item.name || "").toLowerCase());
								return (
									<ListItem disablePadding key={item.id || i}>
										{locked ?
											<button type="button" className='api_list_locked_btn' onClick={() => this.comingSoon()} aria-label={`${item.name} — ${strings.Coming_Soon}`}>
												{this.renderRowBody(item, true)}
											</button>
											:
											<Link to={{ pathname: `/binding/${item.id}` }} style={{ marginBottom: 20, display: "inline-block", width: "100%" }}>
												{this.renderRowBody(item, false)}
											</Link>
										}
									</ListItem>
								);
							})
						}
					</List>
				</div>
			</SubLayout >
		);
	}
}

export default APIBindScreen;
